export default function EmptyState({ icon: Icon, title, description, action }) {
  return (
    <div
      className="card-soft p-10 text-center flex flex-col items-center gap-3"
      data-testid="empty-state"
    >
      {Icon && (
        <div className="w-12 h-12 rounded-full flex items-center justify-center bg-[#FDEBDD] text-[#E85D04]">
          <Icon size={22} />
        </div>
      )}
      <div className="font-display font-semibold text-lg text-[#222]">{title}</div>
      {description && <div className="text-sm text-[#6C757D] max-w-md">{description}</div>}
      {action}
    </div>
  );
}
